<template>
    <div class="bonus-container py-4 col-12 col-sm-10 col-md-9 mx-auto">
        <div class="my-5">
            <h1 class="site-title text-center page-title white-color">Бонусы</h1>
        </div>
        <div class="row mx-0 bonuses-container" v-if="bonuses">
              <div class="col-12 col-sm-12 col-md-6" v-for="i in Math.ceil(bonuses.length/3)" :key="i">
                  <div class="col-12 bonus-item text-white pb-3" v-for="j in 3" :key="j + 'first_column'" v-if="bonuses[(j-1)+(i-1)*3]">
                      <div class="heading col-12 px-0">
                          <div class="row mx-0 py-2 py-xl-0">
                              <div class="col-12 col-xl-9 row mx-0 px-0 justify-content-lg-start">
                                  <div class="col-5 col-sm-3 col-md-5">
                                      <img :src="getIcon(bonuses[(j-1)+(i-1)*3].image)" :alt="bonuses[(j-1)+(i-1)*3].title" class="bonus-img pt-1">
                                  </div>
                                  <div class="col-7 col-sm-9 col-md-7 bonus-heading">
                                      <h4 class="">{{bonuses[(j-1)+(i-1)*3].title}}</h4>
                                  </div>
                              </div>
                              <div class="mt-3 px-1 px-lg-3 bonus-desc" v-html="bonuses[(j-1)+(i-1)*3].description"></div>
                          </div>
                      </div>
                  </div>
              </div>
        </div>
        <div class="row mx-0 justify-content-center w-100" v-else>
            <i class="fa fa-spinner fa-spin fa-fw my-5 orange-color"></i>
        </div>
    </div>
</template>

<script>
    import Config from "@/config";

    const check = require('@/../public/images/icons/bonus/check.png')
    export default {
        data() {
            return {
                check
            }
        },
      computed: {
        bonuses() {
          return this.$store.getters['getBonuses']
        }
      },
      methods: {
        getIcon(icon) {
          return Config.mainStorageUrl + icon;
        }
      }
    }
</script>

<style scoped>
    .bonus-heading {
        display: flex;
        align-items: center;
    }

    .v-sub {
        vertical-align: sub;
    }

    .auto-bonus {
        height: 65px;
        width: 120px;
        background-color: rgba(60, 65, 103, 0.3);;
        float: right;
        border-bottom-left-radius: 50%;
        border-bottom-right-radius: 50%;
    }

    .bonus-item {
        background-color: rgba(62, 101, 129, 0.22);
        border-radius: 10px;
        font-size: 15px;
        margin-bottom: 25px;
    }

    .bonus-img {
        transition: 1s;
        width: 120px;
        height: 120px;
        object-fit: none;
    }

    .bonus-img:hover {
        transform: rotate(10deg);
    }

    .bonus-desc {
        font-size: 14px;
    }

    @media (min-width: 320px) and (max-width: 1366px) {
        h4 {
            font-size: 16px;
        }
    }
</style>
